import 'jquery-validation';
import 'dropzone';
import moment from 'moment';

window.moment = moment;

